export default __webpack_public_path__ + "files/Roadmap_Nitra_Region.docx";